module.exports = __webpack_public_path__ + "img/3DScan_4.3bb5bcf8.png";